import { Helmet } from "react-helmet";
import Loader from "../../Components/Loader";
import { useEffect, useMemo, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import TokenService from "../../Services/Token.service";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { UserService } from "../../Services/User.service";
import { Dropdown, Form as BootstrapForm } from "react-bootstrap";

const US_STATES = [
    "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut",
    "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa",
    "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan",
    "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada",
    "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina",
    "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island",
    "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont",
    "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"
];
const AddAddresses = () => {
    const [loading, setLoading] = useState();
    const location = useLocation();

    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');
    const [navigateToProfileSettings, setNavigateToProfileSettings] = useState(false);

   // Store the transformed address in state
   const [formAddress, setFormAddress] = useState({
    street_address_1: "",
    street_address_2: "",
    city: "",
    state: "",
    // country: "",
    postal_code: "",
    location_type: "",
    // latitude: null,
    // longitude: null,
});
const [isUpdate ,setIsUpdate] = useState(false);
const [stateSearch, setStateSearch] = useState("");
// Run only if location.state?.address exists
// const requestLocationPermission = () => {
    
//     if (!("permissions" in navigator)) {
//         console.error("Permissions API not supported.");
//         return;
//     }

//     navigator.permissions.query({ name: "geolocation" }).then((result) => {
//         if (result.state === "granted") {
//             console.log("Location permission granted.");
//             getUserLocation();
//         } else if (result.state === "prompt") {
//             console.log("Location permission not yet decided. Requesting...");
//             getUserLocation(); // Browser will prompt the user
//         } else if (result.state === "denied") {
//             console.error("Location permission denied. Asking user to enable it.");
//             alert("Location access is required for this feature. Please enable it in your browser settings or enter location details manually");
//         }

//         result.onchange = () => {
//             console.log(`Permission changed to: ${result.state}`);
//             if (result.state === "granted") {
//                 getUserLocation();
//             }
//         };
//     });
// };


// Function to get location
// const getUserLocation = async() => {
    
//     if ("geolocation" in navigator) {
//         navigator.geolocation.getCurrentPosition(
//             async (position) => {
//                 const { latitude, longitude } = position.coords;
//                 const addressDetails =  await fetchAddressFromCoords(latitude, longitude);

//                 // Fetch Address Details using Reverse Geocoding

//                 setFormAddress((prevState) => ({
//                     ...prevState,
//                     latitude,
//                     longitude,
//                     city: addressDetails.city || "",
//                     state: addressDetails.state || "",
//                     country: addressDetails.country || "",
//                     postal_code: addressDetails.postal_code || "",
//                 }));
//             },
//             (error) => {
//                 console.error("Error getting location:", error);
//                 if (error.code === error.PERMISSION_DENIED) {
//                     // alert("Location access denied. Enable it in browser settings.");
//                     requestLocationPermission();
//                 }
//             }
//         );
//     } else {
//         console.error("Geolocation is not supported by this browser.");
//     }
// };

// Function to fetch address details using Reverse Geocoding (OpenStreetMap)
// const fetchAddressFromCoords = async (latitude, longitude) => {
//     try {
        
//         const response = await fetch(
//             `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
//         );
//         const data = await response.json();

//         return {
//             city: data.address.city || data.address.town || data.address.village || "",
//             state: data.address.state || "",
//             country: data.address.country || "",
//             postal_code: data.address.postcode || "",
//         };
//     } catch (error) {
//         console.error("Error fetching address:", error);
//         return {};
//     }
// };

useEffect(() => {
    if (location.state?.address) {
        
        const existingAddress = location.state.address;
        setIsUpdate(Boolean(existingAddress?.address_id));
        setFormAddress({
            address_id: existingAddress.address_id || "",
            street_address_1: existingAddress.address_line_1 || "",
            street_address_2: existingAddress.address_line_2 || "",
            city: existingAddress.city || "",
            state: existingAddress.state || "",
            // country: existingAddress.country || "",
            postal_code: existingAddress.postal_code || "",
            location_type: existingAddress.type || "",
            // latitude : existingAddress.latitude || null,
            // longitude : existingAddress.longitude || null
        });
    } else {
        // If adding a new address, ask for location
        
        // getUserLocation();
    }
}, [location.state?.address]);
// useEffect(() => {
//     if (!location.state?.address) {
//         requestLocationPermission();
//     }
// }, [location.state?.address]);
    const previousUrl = TokenService.getPrevLink();
    const navigate = useNavigate();

    const filteredStates = useMemo(() => {
        return US_STATES.filter((state) =>
            state.toLowerCase().includes(stateSearch.toLowerCase())
        );
    }, [stateSearch]);

    const updateAddress = async (values) => {
        
        setLoading(true);
        try {
            const result = await UserService.updateAddress(values);
            if (result.success) {
                // navigate('/profile-management/profile-settings');
                setToastMessage(result.message);
                setToastVariant('success');
                setNavigateToProfileSettings(true)
            }
            else {
                // navigate('/profile-management/profile-settings');
                setToastMessage(result.message);
                setToastVariant('error');
                setNavigateToProfileSettings(true)

            }
            setLoading(false);
        }
        catch(error) {
            setToastMessage(error.message);
            setToastVariant('error');
            setNavigateToProfileSettings(true)
            setLoading(false);
        }
    }
    const addNewAddress = async (values) => {
        setLoading(true);
        try {
            const result = await UserService.addAddress(values);
            if (result.success) {
                
                setToastMessage(result.message);
                setToastVariant('success');
                setNavigateToProfileSettings(true)
            }
            else {
                setToastMessage(result.message);
                setToastVariant('error');
                setNavigateToProfileSettings(true)
            }
            setLoading(false);
        }
        catch(error) {
            setToastMessage(error.message);
            setToastVariant('error');
            setNavigateToProfileSettings(true)
            setLoading(false);
        }
    }   
        // UseEffect to handle navigation
        useEffect(() => {
            if (navigateToProfileSettings) {
                const timer = setTimeout(() => {
                    navigate('/profile-management/profile-settings',{state: {
                        toastMessage: toastMessage,
                        toastVariant: toastVariant,
                    }},);
                }, );
                
                return () => clearTimeout(timer);
            }
        }, [navigateToProfileSettings]);
    const handleSubmit = async (values, { setSubmitting }) => {
        
        var payload = {
            user_id : TokenService.getUserId(),
            address_1: values.street_address_1,
            address_2: values.street_address_2,
            city : values.city,
            state : values.state,
            // country : values.country,
            postal_code : values.postal_code,
            type :values.location_type,
            // latitude: values.latitude,
            // longitude: values.longitude
        }
        if (isUpdate) {
            payload = {
                ...payload,
                address_id : values.address_id
            }
          // Update existing address
          await updateAddress(payload);
        console.log("edit");
        } else {
            console.log("add");
          // Add new address
        await addNewAddress(payload);
        
        }
      };
      const validationSchema = Yup.object().shape({
        street_address_1: Yup.string()
            .trim()
            .required("Street Address 1 is required"),
        street_address_2: Yup.string().trim(),
        city: Yup.string()
            .trim()
            .required("City is required"),
        state: Yup.string()
            .trim()
            .required("State is required"),
        // country: Yup.string()
        //     .trim()
        //     .required("Country is required"),
        postal_code: Yup.string()
            .trim()
            // .matches(/^\d{6}(-\d{5})?$/, "Invalid postal code format")
            .matches(/^\d{5}$/, "Enter a valid 5-digit postal code")
            .required("Postal Code is required"),
        location_type: Yup.string()
            .trim()
            .required("Location Type is required"),
        // latitude: Yup.number()
        //     .transform((value, originalValue) =>
        //         typeof originalValue === "string" && originalValue.trim() === "" ? null : Number(originalValue)
        //     )
        //     .nullable()
        //     .typeError("Latitude must be a valid number"),
        // longitude: Yup.number()
        //     .transform((value, originalValue) =>
        //         typeof originalValue === "string" && originalValue.trim() === "" ? null : Number(originalValue)
        //     )
        //     .nullable()
        //     .typeError("Longitude must be a valid number"),
    });
    const handleDecimalNumber = (event) => {
        if (event.key === '.' || event.key === "-" || event.key === "+") {
          event.preventDefault();
        }
      };
    return (<>
        <Loader loading={loading} />

        <Helmet>
            <title>DonorX | {!isUpdate? 'Add' : 'Update'} address</title>
        </Helmet>

        <div className="el-middle-wrapper">
            <h2 className="el-title">{!isUpdate? 'Add' : 'Update'} Address</h2>
            <Link className="back-link" to={`${previousUrl}`}><i className='el-icon-back'></i> Profile Settings</Link>

            <Formik 
                validationSchema={validationSchema}
                initialValues={formAddress}
                enableReinitialize={true}
                onSubmit={handleSubmit}
            >
                {({ values, errors, touched, setFieldValue, setFieldTouched }) => (
                    <Form>
                        <div className="el-bg-table el-super-admin mt-3" >
                            <div className="row mt-3 mt-md-0 col-xl-12">
                                {['street_address_1', 'street_address_2', 'city', 'postal_code'].map(field => ( //, 'country', 'latitude', 'longitude'
                                             //&& field !=='latitude'  && field !=='longitude'                                  
                                    <div className="col-md-4" key={field}>
                                        <label htmlFor={field} className="form-label">
                                            {field.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())}
                                            {(field !=='street_address_2' )  && <>          
                                                <span className="text-red">*</span>
                                            </>}
                                        </label>
                                        <Field  
                                            type={field!= 'postal_code' ? 'text' : 'number'}
                                            name={field}
                                            value={values[field] ? values[field] : ''}
                                            className={`form-control  ${field === 'postal_code' ? 'no-arrows' : ''}`}
                                            placeholder={`Enter ${field
                                                .replace(/_/g, ' ')
                                                .trim()
                                                .replace(/\b\w/g, (char) => char.toUpperCase())}`}
                                            onInput={(e) => {
                                                if ( field === 'postal_code' && e.target.value?.length > 6 ) e.target.value = e.target.value?.slice(0, 6);
                                            }}
                                            onKeyDown={handleDecimalNumber}
                                        />
                                        <ErrorMessage name={field} component="div" className="text-danger" />
                                    </div>
                                ))} 
                                {/* State Dropdown */}
                                <div className="col-md-4">
                                    <label htmlFor="state" className="form-label">
                                        State <span className="text-red">*</span>
                                    </label>
                                    <Dropdown className="w-100">
                                        <Dropdown.Toggle
                                            variant="light"
                                            className={`w-100 text-start form-control ${touched.state && errors.state ? "is-invalid" : ""}`}
                                        >
                                            {values.state || "Select State"}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="w-100" style={{ maxHeight: "250px", overflowY: "auto" }}>
                                            <div className="px-2 py-2">
                                                <BootstrapForm.Control
                                                    type="text"
                                                    placeholder="Search state..."
                                                    value={stateSearch}
                                                    onChange={(e) => setStateSearch(e.target.value)}
                                                />
                                            </div>
                                            <Dropdown.Divider />
                                            {filteredStates.length > 0 ? (
                                                filteredStates.map((state) => (
                                                    <Dropdown.Item
                                                        key={state}
                                                        onClick={async () => {
                                                            await setFieldValue("state", state);
                                                            await setFieldTouched("state", true, true);
                                                        }}
                                                    >
                                                        {state}
                                                    </Dropdown.Item>
                                                ))
                                            ) : (
                                                <p className="px-3 text-muted mb-0">No results</p>
                                            )}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    {touched.state && errors.state && (
                                        <div className="invalid-feedback d-block">{errors.state}</div>
                                    )}
                                </div>
                                {/* Location Type Dropdown */}
                                <div className="col-md-4">
                                    <label htmlFor="location_type" className="form-label">
                                        Location Type <span className="text-red">*</span>
                                    </label>
                                    <Field as="select" name="location_type" className="form-control">
                                        <option value="">Select Location Type</option>
                                        {/* <option value="Home">Home</option> */}
                                        <option value="Work">Work</option>
                                        <option value="Office">Office</option>
                                    </Field>
                                    <ErrorMessage name="location_type" component="div" className="text-danger" />
                                </div>      
                            </div>
                            <div className="d-flex align-items-center mt-3">
                                <button type="submit" className="el-main-button me-3">  <span>{!isUpdate? 'Add' : 'Update'}</span></button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>

        </div>

    </>);
}

export default AddAddresses